import { useContext } from "react";
import { PageContext } from '../context';

function useWorkshop() {
  const { 
    workshop, 
    setWorkshop,
    currentWorkshop,
    setCurrentWorkshop,
    scheduleData } = useContext(PageContext);
  const currentSchedule = workshop.workshops[currentWorkshop].schedule;

  return {
    workshop,
    setWorkshop,
    currentWorkshop,
    setCurrentWorkshop,
    currentSchedule,
    scheduleData
  }

  
}

export default useWorkshop;